import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo-feegow.svg'
import _imports_1 from '../assets/logo-vue.png'


const _withScopeId = n => (_pushScopeId("data-v-72dfb1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "header-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logos" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Feegow logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("span", null, "+"),
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_1
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_HelloWorld, { msg: "Feegow Vue.js Development Environment" })
    ])
  ]))
}